import { schemas } from '@convergence/client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { fetch } from '../fetch';

export async function deleteNotebook(title: string) {
  return fetch(
    `/notebook/${title}`,
    { method: 'DELETE' },
    schemas.DeleteNotebookDto
  );
}

export const useDeleteNotebookMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['deleteNotebook'],
    retry: false,
    mutationFn: async (title: string) => {
      const result = deleteNotebook(title);
      return result;
    },

    onSuccess: async () => {
      console.log('deleted notebook');
      await queryClient.invalidateQueries({ queryKey: ['notebooks'] });
    }
  });
};
